/**
 * /accounting/connections merged into Accounts. A bookmark or an old email link
 * takes one hop. The Stripe OAuth return (`connections_.stripe.callback`) keeps
 * its path: Stripe has it registered as the redirect URI.
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_shell/accounting/connections')({
  beforeLoad: () => {
    throw redirect({ to: '/accounting/accounts', replace: true })
  },
})
